export const handleAppDownload = (target: string) => {
  if (target === "apple") {
    window.location.href =
      "https://apps.apple.com/jo/app/wajeez-audiobooks-podcasts/id1483042035";
  } else {
    window.location.href =
      "https://play.google.com/store/apps/details?id=com.faylasof.android.waamda&hl=en&gl=US";
  }
};
